<div>
    <p class="p-16 text-l">
        {{ 'dev.orderStatus.goMyAccount.description' | translate }}
        <span class="link-line text-l" (click)="goMyOrders()">{{ 'dev.orderStatus.goMyAccount.link' | translate }}</span>
    </p>
</div>
